import {useDispatch, useSelector} from 'react-redux'
import {push} from 'connected-react-router'
import {
    BackButton,
    NavigationLinkButton
} from '../components/RegularComponents'
import {saveBusinessLicenceApplicationData} from '../redux/slice/businessLicenceApplicationSlice'
import { replaceUrlParams } from '../app/utils'
import { 
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    APPLICATION_MODE_NEW, 
    APPLICATION_TYPE_COLLECTOR, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT, 
    ROUTE_PATH,
} from '../app/constants'
import { 
    isMortgageTypeApplication,
    applicationTypeFromLicenceSubType,
    isMortgageMainAgentTypeApplication
} from '../redux/slice/applicationsUtils'
import { agencyApplicationSelector } from '../redux/selector/agencyApplicationSelector'
import { currentAgentApplicationSelector } from '../redux/selector/collectorApplicationSelector'
// import {mainTitleMapping} from '../app/utils'

const TopNavigationBar = (props) => {
    const dispatcher = useDispatch()
    const { agencyApplication }  = useSelector(
        agencyApplicationSelector
    );
    const agentApplication = useSelector(currentAgentApplicationSelector);



    const { 
        hideSaveAndExit, 
        topNavigationTitle
    } = props

    let {
        applicationType, 
        applicationMode 
    } = props

    // URL params do not always provide applicationType(applicationType is not always available as prefix), 
    //so retrieving applicationType from application licencingSubType.
    if(!applicationType) {
        if(agentApplication?.licencingSubType) {
            applicationType = applicationTypeFromLicenceSubType(agentApplication.licencingSubType)
        }
        else if(agencyApplication) {
            applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType)
        }
    }

    if(!applicationType) { 
        applicationType = props.match.params.applicationType ?? APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
    }

    if(!applicationMode) { 
        applicationMode = props.match.params.applicationMode ?? APPLICATION_MODE_NEW
    }

    const onSaveExitClick = () => {
        dispatcher(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                // ?
            })
            .catch((error) => {
                // ?
            })
            .finally(() => {
                let appType = applicationType

                if(applicationType === APPLICATION_TYPE_COLLECTOR)
                    appType = APPLICATION_TYPE_COLLECTION_AGENCY
                else if(appType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT)
                    appType = APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
                else if(isMortgageTypeApplication(appType) 
                        && !isMortgageMainAgentTypeApplication(appType)) {
                    appType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
                }

                // dispatcher(push(replaceUrlParams(ROUTE_PATH.WELCOME,appType,applicationMode)))
                //applicationMode should be always new when going to welcome page.
                dispatcher(push(replaceUrlParams(ROUTE_PATH.WELCOME,appType, APPLICATION_MODE_NEW)));
            })
    }

    return (
        <div className="row topMarginNormal">
            <div className="col-3">
                <BackButton 
                    onClick={() => props.history.goBack()} />
            </div>
            <div className="col-6">
                { topNavigationTitle && <span className="navHeader">{topNavigationTitle}</span>}
            </div>
            {!hideSaveAndExit && <div className="col-3 rightAlign">
                <NavigationLinkButton 
                    text={"Save and exit"}  
                    onClick={onSaveExitClick}
                    buttonType={"regular_link"}
                />
            </div>}
        </div>
    )
}

export default TopNavigationBar;
